<template>
  <div id="footer">
  	<div class="panel10">
  	  <ul flex="dir:left" class="footer">
  	    <li class="item" v-for="foot in footers">
  	      <h2 @click="changeMenuIndex($index)">
  	      	{{foot.name}}
  	      	<span class="phoneShow" v-bind:class="{'showUp':menuActiveIndex != $index, 'showDown':menuActiveIndex == $index}"></span>
  	      </h2>
  	      <ul v-bind:class="{active:menuActiveIndex == $index}">
  	      	<li v-for="item in foot.list">
              <a v-link="item.value">{{item.name}}</a></li>
  	      </ul>
  		  </li>
	   </ul>
  	  <div class="flexrow">
  	    <p><span>&copy;</span> iUX Labs  2021 . | 版权所有 . 隐私条款 | 使用条款 |</p>
  	    <p>备案号： <a href="http://beian.miit.gov.cn/" target="_blank" style="color:#939393">沪ICP备14048341号-1</a></p>
  	    <span class=" wxicon">
            <img src="../static/images/iux-wx.jpg" />
			公众号
          </span>
  	  </div>
	 </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      // note: changing this line won't causes changes
      // with hot-reload because the reloaded component
      // preserves its current state and we are modifying
      // its initial state.
      footers:[
        {"name":'咨询',"value":"/consult","key":false,"list":[
          {"name":"所有咨询","value":"/consult","bar":true},
          // {"name":"当前问题","value":"","bar":false},
          {"name":"用户体验咨询","value":"/consult/cstm_exp","bar":false},
          {"name":"品牌数字化战略咨询","value":"/consult/digitalise","bar":false},
          {"name":"转型咨询","value":"/consult/transform","bar":false},
          {"name":"对外","value":"/consult/outside","bar":false},
          {"name":"对内","value":"/consult/inside","bar":false},
          {"name":"管理层","value":"/consult","bar":false}
        ]},
        {"name":'案例',"value":"/case","key":false,"list":[
          {"name":"所有案例","value":"/case","bar":true},
          {"name":"房地产","value":"/case/detail1","bar":false},
          {"name":"高科技","value":"/case/detail2","bar":false},
          {"name":"时尚","value":"/case/detail3","bar":false},
          {"name":"政府","value":"/case/detail4","bar":false},
          {"name":"非盈利组织","value":"/case/detail5","bar":false},
          {"name":"艺术家","value":"/case/detail6","bar":false}
        ]},
        {"name":'解决方案',"value":"/solution","key":false,"list":[
          {"name":"所有方案","value":"/solution","bar":true},
          {"name":"iPad高端品牌体验中心","value":"/solution/exp","bar":false},
          {"name":"高端房地产","value":"/solution/house","bar":false},
          {"name":"影像","value":"/solution/ocean_calendar","bar":false}
        ]},
        {"name":'公司',"value":"/company","key":false,"list":[
          {"name":"公司所有","value":"/company","bar":true},
          {"name":"愿景使命价值观","value":"/company/hope","bar":false},
          {"name":"团队","value":"#","bar":false},
          {"name":"特质","value":"/company/speciality","bar":false},
          {"name":"招募","value":"/company/join","bar":false}
        ]},
        {"name":'合作',"value":"#","key":false,"list":[
          {"name":"共创未来","value":"#","bar":false},
          {"name":"战略合作伙伴","value":"#","bar":false},
          {"name":"行业伙伴","value":"#","bar":false},
          {"name":"资源伙伴","value":"#","bar":false},
          {"name":"区域伙伴","value":"#","bar":false}
        ]},
      ],
      menuActiveIndex:0,
      msg: 'Hello Vue!',
    }
  },
  methods:{
    showChild(index) {
      this.navbars[index].key = true;
    },
    hideChild(index) {
      this.navbars[index].key = false;
    },
    showLeft() {
      this.leftmenu = true;
      this.$dispatch('showLeft',true);
    },
    hideLeft() {
      this.leftmenu = false;
      this.$dispatch('showLeft',false);
    },
    changeMenuIndex(index) {
      console.log(index);
      this.menuActiveIndex = index;
    }
  }
}
</script>
<style lang="sass" scoped>
  * {
    -webkit-flex-wrap:wrap;
    flex-wrap:wrap;
  }
  a {
    text-decoration: none;
  }
	  .flexrow{
		  display:flex;
		  flex-direction:row;
			  align-items: flex-end;
			  justify-content: center;
		  }
  .wxicon{
	  display:flex;
	  flex-direction: column;
	  align-items: center;
		color:#939393;
		font-size: 16px;
  }


  @media screen and (min-width:1080px) {
    .panel10 {
      position: relative;
      height:606px;
      .footer {
        width:1000px;
        margin: 0 auto;
        h2 {
          text-align: left;
          font-size:24px;
          font-weight: 400;
          margin-top: 88px;
        }
        .item {
          width: 14%;
          padding-left: 60px;

          ul {
            width: 118px;
            margin-top: 30px;
            li {
              text-align: left;
              margin-bottom: 15px;
              a {
                font-size: 14px;
                line-height: 24px;
                color:rgb(147,147,147);
                letter-spacing: 1px;
                &:hover {
                  display:inline-block;
                  padding-left: 8px;
                  color:rgb(58,151,247);
                  border-left: 2px solid rgb(58,151,247);
                  cursor: pointer;
                };
              }
            }
          }
        }
      }
      div {
        position: absolute;
        bottom:72px;
        left:0;
        right:0;
        p:nth-child(1) {
          margin-right:89px;
			vertical-align: middle;
			span {
            font-size: 18px;
            vertical-align: middle;
          }
        }
        p:nth-child(2) {
			vertical-align: middle;
				line-height:25px;
					margin-right:140px;
        };
		.wxicon{
			margin-left:120px;
		}
		img {
          width: 118px;
          padding:0 6.5px;
        }
      }
    }
  }
  @media screen and (max-width:1079px) and (min-width: 800px){
    $blockHeight:480px;
    $blockWidth:768px;
    $percent:0.72;
    .panel10 {
      position: relative;
      height: $blockHeight;
      height:650*$percent+px;
      overflow: hidden;
      .footer {
        width:900*$percent+px;
        margin: 0 auto;
        h2 {
          font-size:19*$percent+px;
          margin-top: 55*$percent+px;
        }
        .item {
          width: 15%;
          padding-left: 43*$percent+px;

          ul {
            /*width: 108*$percent+px;*/
            margin-top: 30*$percent+px;
            li {
              margin-bottom: 15*$percent+px;
              font-size: 15*$percent+px;
              color:rgb(147,147,147);
              letter-spacing: 1px;
              a {
                color:rgb(147,147,147);
                &:hover {
                  color:rgb(58,151,247);
                };
              }
              &:hover {
                padding-left: 8*$percent+px;
                color:rgb(58,151,247);
                border-left: 2px solid rgb(58,151,247);
                cursor: pointer;
              };
            }
          }
        }
      }
      div {
        position: absolute;
        bottom:0;
        left:0;
        right:0;
		height: 300px;
        -webkit-transform: scale($percent);
        p:nth-child(1) {
          margin-right:44.2px;

			line-height:25px;
				span {
            font-size: 18px;
            vertical-align: middle;
          }
        }
        p:nth-child(2) {
			line-height:25px;
          margin-right:83.5px;
        };
        img {
          width: 118px*percent;
          padding:0 6.5px;
        }
      }
    }

  }
  @media screen and (max-width:799px) {
  	.panel10 {
      position: relative;
      height: auto;
      .footer {
        width:100%;
        .item {
          width:100%;
          padding:0;
          h2 {
            position: relative;
            font-size:16px;
            padding:0 20px;
            background-color: #f3f3f3;
            height:64px;
            margin:0;
            line-height: 64px;
            span {
              position: absolute;
              top:25px;
              right:20px;
              width:14px;
              height:14px;
              background: url("../static/images/phone/back.png") no-repeat right center;
              background-size: 8px 14px;
              display: inline-block;
              &.showDown {
                background: url("../static/images/phone/down.png") no-repeat right center;
                background-size: 14px 8px;
              }
            }
          }
          ul {
            display: none;
            &.active {
              display: block;
              padding:10px 0;
              margin: 0;
              width:auto;
              li {
                margin: 0;
                padding:10px 20px;
                line-height: 13px;
                a {
                  font-size: 13px;
                  color:rgb(147,147,147);
                  letter-spacing: 1px;
                  &:hover {
                    color:rgb(147,147,147);
                    border-left: none;
                    cursor:none;
                  };
                } 
              }
            }
          }
        }
      }
      div {
        /*$percent:0.8;
        -webkit-transform: scale($percent);
        -webkit-transform: translate(($percent - 1)/2*100%,($percent - 1)/2*100%) scale($percent);*/
        background-color: #f3f3f3;
        position: relative;

			bottom:0;
        padding: 38px 20px 0;
        p {
          line-height: 27px;
        }
        p:nth-child(1) {
          width:100%;
          margin:0;
          span {
            font-size: 18px;
            vertical-align: middle;
          }
        }
        p:nth-child(2) {
          width:100%;
          margin:0;
        }


	  .wxicon{
			padding:25px 0 30px;

  }
        .phoneShow {
          width: 100%;
          padding:25px 0 30px;
          display: block;
          text-align: left;
        }
        img {
          width: 118px;
          padding:0;
        }
      }
    }
  }
</style>


// WEBPACK FOOTER //
// Footer.vue?3f2e2809